export const GET_AUTH_TOKEN="office/auth/token/obtain";
export const GET_REFRESH_AUTH_TOKEN= "office/auth/token/refresh";